/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formvalidation_Requiredtext2Inputs */

const en_formvalidation_requiredtext2 = /** @type {(inputs: Formvalidation_Requiredtext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {Formvalidation_Requiredtext2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_requiredtext2 = /** @type {((inputs?: Formvalidation_Requiredtext2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Requiredtext2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_requiredtext2(inputs)
});
export { formvalidation_requiredtext2 as "formValidation_requiredText" }